
export function getResponsiveMenuWidth (windowWidth) {
    if (windowWidth >= 1440) {
        return 720;
    }

    return Math.min(500, Math.floor(windowWidth * 0.75));

}

export function shouldShowAsidePanel (windowWidth) {
    return windowWidth >= 1000;
}
